module.exports = __webpack_public_path__ + "img/100.fdfc8dd1.svg";